const templates = {
  templates: [
    {
      title: 'CRUD Project Template',
      icon: 'window-restore',
      description:
        'This template creates tickets and documentation for a new feature which requires Create, Read, Update and Delete functionality.',
        parameters: [
            {
                'name': 'Project Name',
                'replace': 'PROJECT_NAME',
                'description': "Name of the project. Singular. Used in ticket in titles and descriptions. Example: '\Product Attribute\' ",
                'value' : ''
            }
        ],
      markdown: `# Create {{PROJECT_NAME}}
// Todo: describe project.



Model: {{PROJECT_NAME}}

| field     | type   | description                       | example   |
|-----------|--------|-----------------------------------|-----------|
| id        | int    | primary key                       | 12        |
| create_dt | Date   | Date the item was created.        | 12-12-12  |
| update_dt | Date   | Date the item was updated.        | 12-12-12  |


## {{PROJECT_NAME}}
The following items can be performed on projects:
* Create
* View
* Update
* Delete

### List {{PROJECT_NAME}}s
Lists all projects in a table, with actions on the right. You may filter the table by both project name and model type. Create date and update date are displayed in the table as well.

Route: /list
 	Layout: full width
	Components:
		* Gridview (name, model, actions)


### View {{PROJECT_NAME}}
Displays data within the test model to the user. The user can edit, delete, archive and restore the test model from this page.

Route: /{id}
	Layout: standard view
	Components: Detail (name, test model, create_dt, update_dt)

### Create {{PROJECT_NAME}}
Allows a user to create the route with a form.

Route: /create
	Layout: stadard view
	Template: form (name, test model)

### Update {{PROJECT_NAME}}
The user may update the project’s name, but not it’s test model. To change a project’s test model, the user must delete the project and recreate it.

Route: /update
	Layout: stadard view
	Template: form (name, test model)

### Delete {{PROJECT_NAME}}
Removes the project from the database.

Route: /delete


### Archive Product
Archives the selected test model

Route: /delete


###  Restore project
Restores an archived test model

Route: /restore


## Add create project buttons
There should be two create project buttons, one should be a plus sign next to the projects main header and the second should be a ‘Create {{PROJECT_NAME}}’ button in the left navigation.


### Add create project plus button next to the '{{PROJECT_NAME}}s' menu item
To right of the {{PROJECT_NAME}}s main navigation is a plus button. Clicking the plus button will bring up the Create {{PROJECT_NAME}}} screen.`,
      config: {
        tickets: [
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          true,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
        ],
        documentation: [
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          true,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
        ],
      },
    },

    {
      title: 'Jira Epic with Stories',
      icon: 'ticket-alt',
      parameters: [
          {
              'name': 'Project Name',
              'replace': 'PROJECT_NAME',
              'description': 'Name of the project. Used in ticket in titles and descriptions.',
              'value' : ''
          }
      ],
      description:
        'This template creates a Jira style epic, its stories, and tasks. It’s a great starting point for a new project.',
      markdown: `# {{PROJECT_NAME}} Epic
Click the right gutter to send lines to tickets and/or documentation. Because both gutters are filled, this line goes to both ticket and documentation.
This line will be the ticket description only, because 'documentation' is turned off in the gutter.
A docs only line. 

## {{PROJECT_NAME}} Story
A story description.

### {{PROJECT_NAME}} Task on story one
The task description.

## A Second {{PROJECT_NAME}} Story
Another description.`,
      config: {
        tickets: [
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
        ],
        documentation: [
          true,
          true,
          false,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    },

    {
      title: 'Blank',
      icon: 'box-open',
      description: 'Start fresh with an empty editor.',
      markdown: "",
      config: {
        tickets: [],
        documentation: [],
      },
    },
  ],
}

export default templates




